var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import { withOutlet, withRouter } from "../componentWrappers";
import RouteHandler from "../App/RouteHandler";
import { actions } from "../BasicReducer";
import { I18NApi, t } from "../I18N";
import api from "../Search/SearchAPI";
import TemplatesAPI from "../Templates/TemplatesAPI";
import ThesauriAPI from "../Thesauri/ThesauriAPI";
import UsersAPI from "../Users/UsersAPI";
import { resolveTemplateProp } from "./utils/resolveProperty";
import { getReadyToReviewSuggestionsQuery } from "./utils/suggestions";
import { UserRole } from "../../shared/types/userSchema";

import { SettingsNavigation } from "./components/SettingsNavigation";
import SettingsAPI from "./SettingsAPI";

class SettingsComponent extends RouteHandler {
  static async requestState(requestParams) {
    const request = requestParams.onlyHeaders();
    const [user, thesauri, translations, collection, templates] = await Promise.all([
    UsersAPI.currentUser(request),
    ThesauriAPI.getThesauri(request),
    I18NApi.get(request),
    SettingsAPI.get(request),
    TemplatesAPI.get(request)]
    );

    const stats = user.role === UserRole.ADMIN ? await SettingsAPI.stats(request) : {};

    // This builds and queries elasticsearch for suggestion counts per thesaurus
    const props = thesauri.
    filter((thesaurus) => thesaurus.enable_classification).
    map((thesaurus) => resolveTemplateProp(thesaurus, templates));
    const allDocsWithSuggestions = await Promise.all(
      [].concat(
        ...props.map((p) =>
        templates.map((template) => {
          const reqParams = requestParams.set(getReadyToReviewSuggestionsQuery(template._id, p));
          return api.search(reqParams);
        })
        )
      )
    );

    // This processes the search results per thesaurus and stores the aggregate  number of documents to review
    const propToAgg = props.map((p) =>
    templates.map((template) => [p, [template, allDocsWithSuggestions.shift()]])
    );
    propToAgg.forEach((tup) => {
      tup.forEach((perm) => {
        const prop = perm[0];
        const results = perm[1][1];
        const uniqueDocs = results.totalRows;

        const thesaurus = thesauri.find((th) => th._id === prop.content);
        if (!thesaurus.hasOwnProperty('suggestions')) {
          thesaurus.suggestions = 0;
        }
        thesaurus.suggestions += uniqueDocs;
      });
    });

    return [
    actions.set('auth/user', user),
    actions.set('dictionaries', thesauri),
    actions.set('translations', translations),
    actions.set('settings/collection', collection),
    actions.set('settings/stats', stats)];

  }

  render() {
    const isSettingsParentRoute = !this.props.outlet;
    return /*#__PURE__*/(
      _jsx("div", { className: "row settings" }, void 0, /*#__PURE__*/
      _jsx(Helmet, {}, void 0, /*#__PURE__*/
      _jsx("title", {}, void 0, t('System', 'Settings', null, false))
      ), /*#__PURE__*/
      _jsx("div", { className: `settings-navigation ${isSettingsParentRoute ? '' : 'only-desktop'}` }, void 0, /*#__PURE__*/
      _jsx(SettingsNavigation, {})
      ), /*#__PURE__*/
      _jsx(Outlet, {})
      ));

  }
}

const Settings = withRouter(withOutlet(SettingsComponent));

export { Settings, SettingsComponent };